import React from 'react';
import a_Product_Data from './a_Product_Data';
import { Cancel } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Link } from 'react-router-dom';
const Cart_Preview = ({ cart, removeFromCart,addToCart, increaseQuantity, decreaseQuantity, removeFromRecent, buttontype }) => {
  // Function to map indexes to product information
  const getProductInfo = (index) => {
    // Get the product information from a_Product_Data based on the index
    if (index >= 0 && index < a_Product_Data.length) {
      const [title, price, category, brand, status] = a_Product_Data[index];
      return { title, price, category, brand, status };
    }
    return { title: "", price: "", category: "", brand: "", status: "" }; // Return empty strings if index is out of bounds
  };

  // Function to calculate the total amount
  const calculateTotalAmount = () => {
    let total = 0;
    cart.forEach(item => {
      const productInfo = getProductInfo(item.index);
      total += productInfo.price * item.count;
    });
    return total;
  };

  // Check if cart is empty
  if (cart.length === 0 && buttontype=='cart') {
      return <div className='text-center small mb-3'>Cart is empty. There are no products in the cart.</div>;    
  }

  return (
    <>    
    
    <div className="cart-preview border-top"> 
    <div className="cart-item ">
            <div className="product-info ">
              <table className='table table-hover1 table-striped1  m-0'>
                <tbody>
                  <tr className='border-start border-end '>                  
                    <th className='bg-theme-secondary-verylight text-theme-seondary'>No</th>
                    <th className='bg-theme-secondary-verylight text--theme-seondary'>Product</th>
                    <th className='bg-theme-secondary-verylight text--theme-seondary'></th>                    
                    <th className='bg-theme-secondary-verylight text--theme-seondary'>Qty</th>
                    <th className='text-end bg-theme-secondary-verylight text--theme-seondary'>Price</th>
                    <th className='bg-theme-secondary-verylight text--theme-seondary'></th> 
                  </tr>
      {cart.map((item, index) => {
        const productInfo = getProductInfo(item.index);
        return (

                  <tr className='border-start border-end hover'>
                    <td className='align-middle px-2 py-0'> <span className='small'> {index+1}</span></td>
                    <td className='align-middle px-2 py-0'>                     
                      <img src="/img/product/img1_1.png" width="60" alt={productInfo.title} />                                            
                      {/* <span>Category: {productInfo.category}</span><br/>
                      <span>Brand: {productInfo.brand}</span><br/>
                      <span>Status: {productInfo.status}</span> */}
                      {/* <span className='small'> {productInfo.title}</span> */}
                    </td>
                    <td className='align-middle px-2 py-0'> <span className='small'> {productInfo.title}</span></td>
                    <td className='align-middle p-0'>
                      <div className='d-flex align-content-between flex-column  h-100'> 
                      {buttontype==='cart' &&
                        <>
                        <Link onClick={() => increaseQuantity(item.index)} className='fs-5 hover-show bg-theme-secondary text-white text-center'>+</Link>
                        <span className='text-center'>{item.count}</span>
                        {item.count !== 1 ? 
                        (  <Link onClick={() => decreaseQuantity(item.index)} className='fs-5 hover-show bg-theme-secondary text-white text-center'>-</Link>)
                        : (<span className='fs-5 hover-show text-white text-center'>-</span>)
                        }
                        </>
                         
                      }
                      {buttontype==='recent' &&
                        <span className='text-center'>{item.count}</span> 
                      }
                      </div>
                      </td>
                    <td className='align-middle px-2 py-0 text-end'><span>${productInfo.price}</span></td>                    
                    <td className='align-middle px-0 pe-1 py-0'>
                      <span className=''>
                      {buttontype==='cart' && <span className=" " onClick={(e) => { e.stopPropagation(); removeFromCart(item.index, item.count); }}>
                        <Cancel style={{fontSize:'25px'}} className='hover-show svg-theme-secondary-verylight hover-svg-theme-accent'/>
                      </span> }
                      {buttontype==='recent' && <span className=" " onClick={(e) => { e.stopPropagation(); removeFromRecent(item.index); addToCart(item.index,item.count);}}>
                        <AddCircleIcon  style={{fontSize:'25px'}} className='text-success hover-svg-theme-secondary'/>
                      </span> }
                      </span>
                      </td>
                  </tr>          
          
        );
      })}   
      {buttontype=='cart' &&  
          <>
          <tr className='border-start border-end '>                  
            <th className='small bg-light' colSpan={4} style={{fontWeight:'400'}}>GST Tax : 2.5%</th>
            <th className='text-end bg-light' style={{fontWeight:'400'}}>${(calculateTotalAmount() * 0.025).toFixed(2)}</th>
            <th className='bg-light'></th> 
          </tr>
{/*           <tr className='border-start border-end'>                  
            <th className='small bg-light' colSpan={4} style={{fontWeight:'400'}}>Free Shipping</th>
            <th className='text-end light' style={{fontWeight:'400'}}>-</th>
            <th className='bg-light'></th> 
          </tr> */}
          <tr className=''>                  
            <td className='bg-theme-secondary text-white' colSpan={4}><b>Total Amount : </b> <span className="opacity-7">( * Free Shipping)</span></td>
            <td className='text-end bg-theme-secondary text-white'> <b>${(calculateTotalAmount() * 1.025).toFixed(2)}</b></td>
            <td className='bg-theme-secondary text-white'></td> 
          </tr>
          </> 

          }
        </tbody>
        </table> 
 
    </div>
    </div>
    </div>
    </>
  );
};

export default Cart_Preview;